<template>
  <v-card elevation="2" :loading="loading ? '#003893' : false">
    <v-card-title class="text-uppercase">
      <div>Operational availability</div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center justify-space-between" style="gap: .5rem">
        <ExportShortcut
          reportCode="FacilityGroupOperationalAvailabilitylarge"
        />
        <WidgetInfo
          v-if="report.information"
          title="Operational availability"
          :content="report.information"
        />
      </div>
    </v-card-title>
    <v-card-text>
      <v-row style="height:440px">
        <v-col align="center" cols="4" xs="12" sm="12" md="12" lg="5" class="align-self-end text-carbon">
          <div style="height: 100%; " >
            <div style="height: 250px; width:100%; ">
              <vue-speedometer
              :forceRender="true"
              :width="400"
              :height="250"
              valueTextFontSize="30px"
              :minValue="90"
              :maxValue="100"
              :segments="4"
              :customSegmentStops= '[90, 96, 98, 100]'
              needleColor="#9E9E9E"
              startColor="#60AFDD"
              endColor="#003893"
              :segmentColors='["#3074B8", "#1856a6", "#003893"]'
              :value="speedometer.needle"
              :currentValueText="loading ? ' ' : `${speedometer.actual ? `${speedometer.actual}%` : 'No data'}`"
              />
            </div>
          </div>
        </v-col>
        <v-col cols="8" xs="12" sm="12" md="12" lg="7">
          <FleetUptimeChart :ships="chartData" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" xs="12" sm="12" md="12" lg="5">
          <p class="text-center">
            Average scrubber operational availability
          </p>
        </v-col>
        <v-col cols="8" xs="12" sm="12" md="12" lg="7">
          <p class="text-center">
            Operational availability for each vessel
            <br>
            <v-icon color="#003893">mdi-window-minimize</v-icon> Average operational availability for fleet
          </p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import VueSpeedometer from 'vue-speedometer';
import WidgetBanner from '@/components/WidgetBanner.vue';
import FleetUptimeChart from '@/components/FleetUptimeChart.vue';
import WidgetInfo from '@/components/WidgetInfo.vue';
import ExportShortcut from '../components/ExportShortcut.vue';

export default {
  name: 'FleetUptimeLarge',
  components: {
    VueSpeedometer,
    WidgetBanner,
    FleetUptimeChart,
    WidgetInfo,
    ExportShortcut
  },
  props: {
    period: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      report: {}
    }
  },
  computed: {
    speedometer() {
      const value = this.report?.fields?.Average?.value;
      const format = this.report?.fields?.Average?.format || 'Percent1Digits';

      const data = { actual: 0, needle: 90 };

      if (!this.loading && value && format) {
        data.actual = Number(this.$options.filters.formatKPI(value, format));

        // Set needle value to cap overflow
        data.needle = data.actual < 80 ? 80 : data.actual;
      }

      return data;
    },
    chartData() {
      const format = this.report?.fields?.Values?.format || 'Percent1Digits';
      let values = this.report?.fields?.Values?.values || [];

      const ships = values.map(x => {
        return {
          value: Number(this.$options.filters.formatKPI(x.value, format)),
          name: this.$store.getters.facilityById(x.facilityId).name
        };
      });

      ships.sort((a, b) => {
        return String(a.name).localeCompare(b.name);
      });

      return ships;
    },
    ...mapState([ 'filteredFacilities' ])
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.report = {};

      try {
        this.report = await this.$Services.reports.getReportValues('FacilityGroupOperationalAvailabilitylarge', this.period.from, this.period.to);
        
      } catch (error) {
        console.error(error);
        this.$store.dispatch('showDefaultError');
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    period() {
      this.fetchData();
    },
    filteredFacilities() {
      this.fetchData();
    }
  }
}
</script>